import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { THEME } from '../../config/theme';

// Set up the context to be used for dark/light theme
export const ThemeContext = React.createContext({});

/**
 * Manages getting the black/white CSS variables and setting the the "--theme-"
 * variables for controlling theme colors
 * @param {string} value
 */
const updateCssVariables = (value) => {
  // Get CSS variables for black/white so they can be used.
  const colors = getComputedStyle(document.body);
  const dark = colors.getPropertyValue('--black');
  const light = colors.getPropertyValue('--white');

  if (value === THEME.DARK) {
    document.documentElement.style.setProperty('--theme-background', dark);
    document.documentElement.style.setProperty('--theme-text-color', light);
  } else {
    document.documentElement.style.setProperty('--theme-background', light);
    document.documentElement.style.setProperty('--theme-text-color', dark);
  }
};

const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(undefined);

  // Set the initial theme state based on the initial-color-mode value obtained in gatsby-ssr
  useEffect(() => {
    const root = window.document.documentElement;
    const initialColorValue = root.style.getPropertyValue('--initial-color-mode');
    setTheme(initialColorValue);
  }, []);

  // Handle updating the theme state when the toggle is clicked, as well as updating
  // the css variables and localStorage value
  const setColorTheme = (value) => {
    setTheme(value);
    updateCssVariables(value);
    window.localStorage.setItem('theme', value);
  };

  return (
    <ThemeContext.Provider value={{ theme, setColorTheme }}>
      <div className={theme}>
        {children}
      </div>
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ThemeProvider;
